import { TCategory } from 'data';
import { PreparedCategoryData } from '../../../utils';

export enum CardType {
	catalogueOrder = 'catalogueOrder',
	popularOrder = 'popularOrder',
	popular = 'popular',
}

export type CardClickHandler = (data: PreparedCategoryData, isCommonService?: boolean) => void;

export type CardProps = {
	categoryData: TCategory;
	cardType: keyof typeof CardType;
	className?: string;
	isVisible?: boolean;
	onClickHandler?: CardClickHandler; // нужен только для "популярных карточек" в регионах для открытия модалки
};
